var _rect, _path, _path2, _circle, _circle2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTransportation = function SvgTransportation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#1C9ABB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.01 20.26a2 2 0 0 1 2.173-1.742l6.817.649 6.817-.65a2 2 0 0 1 2.174 1.744l.311 2.491A2 2 0 0 1 27.318 25H12.682a2 2 0 0 1-1.984-2.248l.311-2.491Z",
    stroke: "#fff",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 25h3.333v1.917a1 1 0 0 1-1 1H13.5a1 1 0 0 1-1-1V25ZM24.167 25H27.5v1.917a1 1 0 0 1-1 1h-1.333a1 1 0 0 1-1-1V25ZM13.752 13.95a2 2 0 0 1 1.923-1.45h8.65a2 2 0 0 1 1.923 1.45l1.252 4.383-7.5.834-7.5-.834 1.252-4.382Z",
    fill: "#fff",
    fillOpacity: 0.56,
    stroke: "#fff",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.208,
    cy: 21.667,
    fill: "#fff",
    r: 1.042
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.792,
    cy: 21.667,
    fill: "#fff",
    r: 1.042
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 16.667h1.25M11.25 16.667h1.25",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
export default SvgTransportation;